import axios from "axios";
import { cleanObject } from "helper/cleanObject";

const path = "/banners/";

export const bannerService = {
  async list(filter = {}) {
    let searchParams = new URLSearchParams(cleanObject(filter));
    return await axios.get(path + "?" + searchParams.toString());
  },

  async view(id) {
    return await axios.get(path + id);
  },

  async update(id, payload) {
    return await axios.patch(path + id, payload);
  },

  async create(payload) {
    return await axios.post(path, payload);
  },

  async remove(id) {
    return await axios.delete(path + id);
  },
};
